// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetJavaScriptUrlRequestModel from '../../model/get-widget-java-script-url-request-model';
import GetWidgetJavaScriptUrlRequestDTO from '../dto/get-widget-java-script-url-request-dto';
import dtoSchema from '../schemas/get-widget-java-script-url-request-schema';

export default abstract class GetWidgetJavaScriptUrlRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetJavaScriptUrlRequestDTO>) {
    super();
    if (data) {
      this.successUrl = data.successUrl ?? undefined;
      this.failedUrl = data.failedUrl ?? undefined;
      this.id = data.id;
    }
  }
  /**
  */
  successUrl?: string;
  /**
  */
  failedUrl?: string;
  /**
  */
  id?: string;

  static toModel(dto: DeepPartial<GetWidgetJavaScriptUrlRequestDTO>): GetWidgetJavaScriptUrlRequestModel;
  static toModel(dto: DeepPartial<GetWidgetJavaScriptUrlRequestDTO> | undefined | null): GetWidgetJavaScriptUrlRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetJavaScriptUrlRequestDTO> | undefined | null): GetWidgetJavaScriptUrlRequestModel | undefined {
    return dto ? new GetWidgetJavaScriptUrlRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetJavaScriptUrlRequestModel> | GetWidgetJavaScriptUrlRequestModel): GetWidgetJavaScriptUrlRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      successUrl: unwrapped.successUrl,
      failedUrl: unwrapped.failedUrl,
      id: unwrapped.id,
    } as GetWidgetJavaScriptUrlRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetJavaScriptUrlRequestModel, can not map to GetWidgetJavaScriptUrlRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
